import React, { Fragment } from 'react';

import { bool, string } from 'prop-types';

import { Container, Ball } from './styles';

const LoadingSpinner = ({ isLoading, color }) => {
  return isLoading ? (
    <Container color={color}>
      <Ball />
      <Ball />
      <Ball />
    </Container>
  ) : (
    <Fragment />
  );
};

LoadingSpinner.propTypes = {
  isLoading: bool,
  color: string,
};

LoadingSpinner.defaultProps = {
  isLoading: false,
  color: '',
};

export default LoadingSpinner;
